import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14.602 8.667a.67.67 0 0 0-.7-.094 5.4 5.4 0 0 1-2.247.487 5.433 5.433 0 0 1-5.426-5.4c.003-.45.059-.897.166-1.333a.667.667 0 0 0-.886-.754 6.76 6.76 0 1 0 9.333 7.794.67.67 0 0 0-.24-.7m-6.333 4.46A5.426 5.426 0 0 1 4.895 3.48v.18a6.767 6.767 0 0 0 8.16 6.613 5.41 5.41 0 0 1-4.786 2.88z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })